import React from 'react'
import PropTypes from 'prop-types'
import './styles'

import humanize from 'underscore.string/humanize'
import Model from '/lib/model'

export default \
class Cluster extends React.Component
  @propTypes:
    model:  PropTypes.instanceOf(Model).isRequired
    attrs:  PropTypes.arrayOf(PropTypes.string).isRequired
    type:   PropTypes.string
    title:  PropTypes.string

  render: ->
    cn = @props.type or @props.model.constructor.className
    <div className="Cluster #{cn}" title={@props.title}>
      {for key in @props.attrs
        <span className="label label-inverted #{key}" disabled={!@props.model[key]}>
          {humanize key}
        </span>
      }
    </div>
